<template>
  <div class="aboutUs">
    <div class="swiper">
        <img class="swiper-img" src="@/assets/images/aboutUs/Themainvisualfigure.jpg" alt="">
    </div>
    <div class="product">
      <div class="product-list">
        <div class="list-title">
          <span class='line'></span>
          <span class="big-classify">Introduction of Westingarea Supply Chain</span>
          <span class='line'></span>
        </div>
        <div class="list-intro">Founded in 2002, Westingarea Supply Chain had entered the B2B industry providing MRO (Maintenance, Repair and Operations) products in 2009. After nearly 10 years' development in B2B E-commerce industry of MRO products, it has already developed into a leading MRO E-commerce company in China. </div>

        <div class="list-intro">At present, CICC ALPHA, IDG, Fortune Link, FORTUNE CAPTIAL, etc. have become shareholders of Westingarea Supply Chain. Westingarea Supply Chain is committed to becoming a trusted MRO partner. With more than 100 industry experts, 36 product lines, 5000+ Categories, 1000000+ product SKU, Westingarea Supply Chain is providing professional product and service to over 20000 industrial end-users in China. </div>

        <div class="list-intro">Typical customers in various industries are: Automobile and Parts - Continental, ZF, Schaeffler; Chemical – DOW, Dupont, DSM, EVONIK; Pharmaceuticals - Sanofi, Roche, AstraZeneca; Electrical Manufacturing - ABB, Siemens, Hitachi; Mechanical Manufacturing - Atlas, Donnelly, Tetra Pak; Consumer Products - Mars, Carlsberg, Nestle; Home Appliances and Electronics - A.O. Smith, BSH; Raw Materials -3M, Saint-Gobain, Asia Pulp and Paper; Energy – CHN ENERGY, Sinopec, etc.</div>
      </div>
    </div>

    <div class="intro">
      <div class="intro-title">
        <div class="line"></div>
        <div class="title-content-border">
          <div class="title-content-box">
            <p class="title-content">Headquarters,</p>
            <p class="title-content"> Shanghai Office of</p>
            <p class="title-content">Westingarea Supply Chain</p>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <img class='office-img' src="@/assets/images/home/bangongshi24.jpg" alt="">
    </div>

    <div class="intro">
      <div class="intro-title">
        <div class="line"></div>
        <div class="title-content-border">
          <div class="title-content-box">
            <p class="title-content">Corporate Milestones</p>
            <!--<p class="title-content">aeqrqrqwerqqerqerqed</p>-->
          </div>
        </div>
        <div class="line"></div>
      </div>
      <div class="time">
        <div class="time-classify">
          <div class="time-detail time2002">
            <div class="time-event">
              <p>Registered and established in Shanghai, China</p>
            </div>
            <div class="circle-time">
              <div class="detail-time">2002</div>
              <div class="circle"></div>
            </div>
          </div>
          <div class="time-detail time2009">
            <div class="circle-time">
              <div class="circle"></div>
              <div class="detail-time">2009</div>
            </div>
            <div class="time-event">
              <p> Develop domestic MRO industrial commodity market</p>
            </div>


          </div>
          <div class="time-detail time2011">
            <div class="time-event">
              <p>Acquired Angel financing and Completed “A” Round
                financing from FORTUNE CAPITAL</p>
            </div>
            <div class="circle-time">
              <div class="detail-time">2011</div>
              <div class="circle"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="time last-time">
        <div class="time-classify time-classify2">
          <div class="time-detail time2012">
            <div class="time-event">
              <p>30,000m2 Asia Pacific Logistic
                Center launched in Zhejiang.</p>
            </div>

            <div class="circle-time">
              <div class="detail-time">2012</div>
              <div class="circle"></div>
            </div>
          </div>
          <div class="time-detail time2015-1">
            <div class="circle-time">
              <div class="circle"></div>
              <div class="detail-time">2015</div>
            </div>
            <div class="time-event">
              <p>"B" Round financing from IDG; professional MRO online retailer in China</p>
            </div>
          </div>
          <div class="time-detail time2015-2">
            <div class="time-event">
              <p>"C" Round financing from China-Belgium Fund ,ChinaLink, Fortune Link and JWVENTURES.</p>
            </div>
            <div class="circle-time">
              <div class="detail-time">2015</div>
              <div class="circle"></div>
            </div>
          </div>
          <div class="time-detail time2017-1">
            <div class="circle-time">
              <div class="circle"></div>
              <div class="detail-time">2017</div>
            </div>
            <div class="time-event">
              <p>Completed "D" Round financing from CICC ALPHA</p>
            </div>
          </div>
          <div class="time-detail time2017-2">
            <div class="time-event">
              <p> E-commerce Demonstration
                Enterprise from China Ministry of Commerce</p>
            </div>
            <div class="circle-time">
              <div class="detail-time">2017</div>
              <div class="circle"></div>
            </div>
          </div>
          <div class="time-detail time2020">
            <div class="circle-time">
              <div class="circle"></div>
              <div class="detail-time">2020</div>
            </div>
            <div class="time-event">
              <p> Implement new strategy, a global professional MRO online retailer</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="intro">
      <div class="intro-title">
        <div class="line"></div>
        <div class="title-content-border">
          <div class="title-content-box">
            <p class="title-content">Supply Chain Management</p>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <div class="show-img">
        <div class="entrepot-img-box">
          <img class='entrepot-img' src="@/assets/images/aboutUs/Sitecutfigure1.jpg" alt="">
          <p class='entrepot-intro'>Stock Service</p>
        </div>
        <div class="entrepot-img-box">
          <img class='entrepot-img' src="@/assets/images/aboutUs/Sitecutfigure2.jpg" alt="">
          <p class='entrepot-intro'>Digital Management</p>
        </div>
        <div class="entrepot-img-box">
          <img class='entrepot-img' src="@/assets/images/aboutUs/Sitecutfigure3.jpg" alt="">
          <p class='entrepot-intro'>36000m2 Logistic Center</p>
        </div>
      </div>
    </div>

    <footer-content></footer-content>
  </div>
</template>

<script>
  import footerContent from '@/components/footer.vue';
  export default {
    name: "home",
    components: {
      footerContent
    },
    data () {
      return{

      }
    }
  }
</script>

<style scoped>
  .el-carousel__item{
    height: auto;
  }
  /deep/ .el-carousel__container{
    height: auto;
  }

  /deep/ .el-carousel__arrow{
    width: 50px;
    height: 50px;
    font-size: 35px;
  }
  .swiper{
    width:100%;
  }
  .swiper .swiper-img{
    width: 100%;
  }
  .product{
    padding:60px 60px 0;
  }
  .product .product-list{
    width:100%;
    margin-top: 60px;
  }
  .product .product-list .list-title {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;
  }
  .product .product-list .list-title .line{
    width: 150px;
    height: 1px;
    background: #b7b7b7;
  }
  .product .product-list .list-title .big-classify{
    font-size: 27px;
    margin: 0 20px;
    font-weight: bold;
  }
  .product .product-list .list-intro{
    width: 98%;
    font-size: 15px;
    color: #1f1f1f;
    line-height: 26px;
    margin: 15px auto;
    text-align: left;
    text-indent:2em;
  }



  .intro{
    margin-top: 146px;
  }
  .intro .intro-title{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .intro .intro-title .line{
    width: 120px;
    height: 1px;
    background: #b7b7b7;
  }

  .intro .intro-title .title-content-border{
    width: 200px;
    height: 200px;
    border-radius: 50%;
    margin: 0 50px;
    border: 1px solid #b7b7b7;
    position: relative;
  }
  .intro .intro-title .title-content-box{
    width: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .intro .intro-title .title-content-box .title-content{
    font-size: 14px;
    line-height: 30px;
    font-weight: bold;
    text-align: center;
  }
  .intro .office-img{
    display: block;
    width: 90%;
    margin: 80px auto;
    border-radius: 15px;
  }

  .intro .show-img{
    width: 78%;
    margin: 80px auto 130px;
    display: flex;
    justify-content: space-between;
  }
  .intro .show-img .entrepot-img-box{
    width: 29%;
    text-align: center;
  }
  .intro .show-img .entrepot-img-box .entrepot-img{
    width: 100%;
  }

  .intro .show-img .entrepot-img-box .entrepot-intro{
    font-size: 18px;
    color: #767676;
    margin-top: 10px;
  }



  .intro .time{
    width: 100%;
  }
  .intro .time .time-classify{
    width: 100%;
    height: 1px;
    background: #b7b7b7;
    margin-top: 200px;
    position: relative;
  }
  .intro .time .time-classify .time-detail{
    position: absolute;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 30%;
    height: 120px;
  }
  /*奇数行*/
  .intro .time .time-classify .time-detail:nth-child(odd){
    bottom: -6px;
  }

  /*偶数行*/
  .intro .time .time-classify .time-detail:nth-child(even){
    top: -6px;
  }
  .time .time-classify .time-detail .circle-time{
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .time .time-classify .time-detail .circle{
    width:12px;
    height: 12px;
    border-radius: 50%;
    background: #000;
  }
  .time .time-classify .time-detail .time-event{
    width: 100%;
    font-size: 14px;
    overflow-wrap: break-word;
    text-align: center;
    color: #767676;
  }
  .detail-time{
    font-weight: bold;
    font-size: 13px;
  }
  .intro .time .time-classify.time-classify2 .time-detail{
    width: 20%;
  }

  .intro .time .time-classify .time-detail.time2002{
    left:22%;
  }

  .intro .time .time-classify .time-detail.time2009{
    left: 50%;
  }

  .intro .time .time-classify .time-detail.time2011{
    left: 78%;
  }
  .intro .time.last-time{
    margin: 330px 0 230px;
  }
  .intro .time .time-classify .time-detail.time2012{
    left: 16%;
  }

  .intro .time .time-classify .time-detail.time2015-1{
    left: 29.6%;
  }

  .intro .time .time-classify .time-detail.time2015-2{
    left: 43.2%;
  }

  .intro .time .time-classify .time-detail.time2017-1{
    left: 56.8%;
  }

  .intro .time .time-classify .time-detail.time2017-2{
    left: 70.4%;
  }

  .intro .time .time-classify .time-detail.time2020{
    left: 84%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs/index.vue